import router from '@/router'
import {verifyChannel} from '@/api/guide'
// export function getImgUrl(imgUrl, urlList = {}, domain = '') {
//   if (!imgUrl) return null
//   const keys = Object.keys(urlList)
//   console.log(keys,imgUrl,'imgimggim',imgUrl.indexOf(keys[1]))
//   if (keys.length === 0) {
//     return imgUrl
//   }
//   const _target = keys.find((_k) => {
//     return imgUrl.indexOf(_k) == 1
//   })
//   console.log(_target,'_target_target')
//   if (!_target) {
//     if (/^http/.test(imgUrl)) return imgUrl
//     return domain + imgUrl
//   }
//   const _subStr = imgUrl.replace('/' + _target, '')
//   console.log(urlList[_target].imageUrl + _subStr,'imgresult',urlList[_target].imageUrl)
//   return urlList[_target].imageUrl + _subStr
// }
export function getImgUrl(url, perfix, domain = '') {
  if (!url) return ''
  let imgAddr = ''
  const imgArr = perfix
  // 资源前缀修改 改为多桶名路径 对比相同桶名的路径
  const bucket = url.split('/')[1]
  for (let key in imgArr) {
    if (key === bucket) {
      // 桶名对比成功 使用当前桶名下的域名
      imgAddr = imgArr[key].imageUrl
    }
  }
  if (!url || /^http/.test(url)) {
    return url
  } else {
    if (imgAddr) {
      url = url.replace('/' + bucket, '')
      return `${imgAddr}${/^\//.test(url) ? '' : '/'}${url}`
    } else {
      // 未对比到桶名 使用默认资源域名
      imgAddr = domain
      return url
    }
  }
}

/** 检测当前设备信息*/
export function checkDevice() {
  var u = navigator.userAgent
  let deviceInfo = {}
  deviceInfo.isAndroid = !!(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) //android终端
  deviceInfo.isiOS = !!u.match(/(iPhone|iPod|ios|iPad)/i) //ios终端
  deviceInfo.issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  deviceInfo.isMobile = deviceInfo.isAndroid || deviceInfo.isiOS
  window.deviceInfo = deviceInfo
  return deviceInfo
}

/**
 *
 * base64加密
 */
export function base64Encode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode('0x' + p1)))
}

export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16).toUpperCase()
  })
}

export function lightPackege(imgSrc, url, appName, appId, foreign = false) {
  var base64Str = imgSrc.replace(/^data:image\/\w+;base64,/, '')
  var iconXML = base64Str?.length ? `<key>Icon</key><data>${base64Str}</data>` : ''
  // URL是必填的
  var URL = `<key>URL</key><string>${url}</string>`
  var xmlText = `<?xml version="1.0" encoding="UTF-8"?>
  <!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
  <plist version="1.0">
  <dict>
	  <key>PayloadContent</key>
	  <array>
		  <dict>
			  <key>FullScreen</key>
			  <true/>
			  ${iconXML}
			  <key>IgnoreManifestScope</key>
			  <true/>
			  <key>IsRemovable</key>
			  <${true}/>
			  <key>Label</key>
			  <string>${appName}${foreign ? '-海外版' : ''}</string>
			  <key>PayloadDescription</key>
			  <string>${appName}${foreign ? '-海外版' : ''}WebClip配置</string>
			  <key>PayloadDisplayName</key>
			  <string>Web Clip</string>
			  <key>PayloadIdentifier</key>
			  <string>com.apple.webClip.managed.${appId}</string>
			  <key>PayloadType</key>
			  <string>com.apple.webClip.managed</string>
			  <key>PayloadUUID</key>
			  <string>${appId}</string>
			  <key>PayloadVersion</key>
			  <integer>1</integer>
			  <key>Precomposed</key>
			  <true/>
			  ${URL}
		  </dict>
	  </array>
	  <key>PayloadDisplayName</key>
	  <string>${appName}${foreign ? '-海外版' : ''}</string>
	  <key>PayloadIdentifier</key>
	  <string>CoderWGBDeMacBook-Pro.${appId}${foreign ? '-1' : ''}</string>
	  <key>PayloadRemovalDisallowed</key>
	  <false/>
	  <key>PayloadType</key>
	  <string>Configuration</string>
	  <key>PayloadUUID</key>
	  <string>${getUUID()}</string>
	  <key>PayloadVersion</key>
	  <integer>1</integer>
  </dict>
  </plist>`

  console.log(url, appName)
  var base64 = 'data:application/x-apple-aspen-config;base64,' + btoa(unescape(encodeURIComponent(xmlText)))
  window.location.href = base64
  window.setTimeout(function () {
    window.location.href = 'shortcuts://x-callback-url/run-shortcut?x-error=App-prefs:root=General&path=ManagedConfigurationList/PurgatoryInstallRequested'
  }, 3000)
}
export function getChannelCode() {
  let channelCode = process.env.VUE_APP_CODE
  if (queryURLparamsRegEs6(window.location.href) && queryURLparamsRegEs6(window.location.href).a) {
    let encStr = atob(queryURLparamsRegEs6(window.location.href).a)
    const regx = /##(.*)##(.*)##(.*)##/
    console.log(encStr, 'encStr')
    const matchArr = encStr.match(regx)
    if (matchArr && matchArr[1]) {
      channelCode = matchArr[1]
    }
  }

  return channelCode
}
function queryURLparamsRegEs6(url) {
  let obj = {}
  // 使用更精确的正则表达式来匹配URL参数，考虑到参数值可能包含&和=等字符（URL编码后）
  let reg = /([^?=&]+)=([^&]*)/g
  let match
  while ((match = reg.exec(url.slice(url.indexOf('?') + 1))) !== null) {
    // decodeURIComponent用于解码URL组件，确保特殊字符被正确处理
    obj[decodeURIComponent(match[1])] = decodeURIComponent(match[2])
  }
  return obj
}
